import { initTabsBlock } from '../../src/js/tabs';
import { bootBlock } from '../../src/js/block-boot';

bootBlock('products-tabs', (root) => {
  initTabsBlock('.products-tabs', true, root);
});
